import { Link } from 'react-router';

import './TopNav.css'

function TopNav() {
	return (
		<nav className="topnav">
			<div className="logo"><span>Eyes on</span> Environmental Enforcement</div>

			<div className="nav-links">
				<Link to="/">Home</Link>
				<Link to="portal">Search Portal</Link>
				<Link to="why-this-matters">Why This Matters</Link>
				<Link to="project-background">Project Background</Link>
				<Link to="about-data">About the Data</Link>
				<Link to="portal-info">Search Information</Link>
				<Link to="uses">Suggested Uses</Link>
				<Link to="collaborators">Collaborators</Link>
				<Link to="contact">Contact Us</Link>
			</div>
		</nav>
	)
}

export default TopNav;
